import { Badge, BadgeProps } from '@fluentui/react-components';

import { CHANGE_STATUS } from '../constants';
import { toSentenceCaseLabel } from '../helpers';

const getChangeStatusBadgeColor = (status: string): BadgeProps['color'] => {
  switch (status.toLocaleLowerCase()) {
    case CHANGE_STATUS.AI_ASSESSMENT_IN_PROGRESS.toLocaleLowerCase():
      return 'informative';
    case CHANGE_STATUS.ADDITIONAL_INFORMATION_REQUIRED.toLocaleLowerCase():
      return 'warning';
    case CHANGE_STATUS.ASSESSMENT_COMPLETE_PENDING_APPROVAL.toLocaleLowerCase():
    case CHANGE_STATUS.APPROVED_FOR_EXECUTION.toLocaleLowerCase():
      return 'success';
    case CHANGE_STATUS.PENDING_REVIEW.toLocaleLowerCase():
      return 'warning';
    case CHANGE_STATUS.IN_EXECUTION.toLocaleLowerCase():
      return 'informative';
    case CHANGE_STATUS.IMPLEMENTED.toLocaleLowerCase():
      return 'brand';
    case CHANGE_STATUS.CLOSED.toLocaleLowerCase():
      return 'success';
    default:
      return 'subtle';
  }
};

type TProps = {
  status: string;
  className?: string;
  size?: BadgeProps['size'];
};

const ChangeStatusBadge = ({ status, className, size = 'extra-large' }: TProps) => (
  <Badge appearance="tint" color={getChangeStatusBadgeColor(status)} size={size} className={className}>
    {toSentenceCaseLabel(status)}
  </Badge>
);

export default ChangeStatusBadge;
